import { ToastContainer } from 'react-toastify'
import { useInsurance } from './hooks/useInsurance'
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper, FormControl, InputLabel, Button, } from '@mui/material'
import { TableHeader } from '../../../../components/Table/TableHeader'
import { Spinner } from '../../../../components/spinner/Spinner'
import { Modal } from 'react-bootstrap'
import { Pagination } from '../../../../components/Table/Pagination'
import { Select, MenuItem, TextField, Autocomplete } from '@mui/material'
import DatePicker from '../../../../components/DatePicker'
import InputMask from 'react-input-mask'
import { useSelector } from 'react-redux'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'
import { PlanTypeData } from '../../../../constants'
import {environment} from '../../../../env/environment'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import filePdf from '../../../../assets/images/file.png'

export default function InsuranceList() {
    const { user: currentUser } = useSelector((state) => state.auth)
    const { data, method } = useInsurance()
    const {
        insuranceList,
        insurancListHeadCells,
        spinner,
        controller,
        totalCount,
        notesModel,
        addInsuranceData,
        ListState,
        insuranceDetailsModel,
        date,
        addSubscriberData,
        validation,
        ListCountry,
        ListStateInsurrance,
        userIdCard,
        userIdCardForm,
        coverage,
        searchFilter,
    } = data
    const {
        setController,
        changeStatusInsurance,
        handleChangeCountryForInsurance,
        setNotesModel,
        handleDateChange,
        handleChangeCountry,
        setInsuranceDetailsModel,
        UpdateInsurance,
        handleInputChange,
        getCountryList,
        setInsuranceData,
        handleUploadChange,
        saveAndAddNew,
        handleRemoveDocument,
        submit,
        autoFill,
        setcoverage,
        setdate,
        setUserIdCard,
        refetch,
        handleSearchFilter,
        resetFilter,
    } = method

    return (
        <div>
            {spinner && <Spinner />}
            <ToastContainer />
            <div className="d-flex justify-content-between mt-2 ms-3 me-3">
                <div className="d-flex">
                    <div style={{ width: '130px' }} className="me-2">
                        <FormControl fullWidth>
                            <InputLabel>Coverage</InputLabel>
                            <Select
                                name="search_coverage"
                                className="w-100"
                                size="small"
                                label="Coverage"
                                value={searchFilter.search_coverage || ''}
                                onChange={(e) => handleSearchFilter(e)}
                            >
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="Primary">Primary</MenuItem>
                                <MenuItem value="Secondary">Secondary</MenuItem>
                                <MenuItem value="Tertiary">Tertiary</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ width: '130px' }} className="me-2">
                        <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select name="isActive" className="w-100" size="small" label="Status" value={searchFilter.isActive || ''} onChange={(e) => handleSearchFilter(e)}>
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="true">Enabled</MenuItem>
                                <MenuItem value="false">Disabled</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <Button className="me-2" variant="contained" onClick={() => refetch(searchFilter)} startIcon={<SearchIcon />}>
                        Search
                    </Button>
                    <Button variant="contained" onClick={() => resetFilter()} startIcon={<RestartAltIcon />}>
                        Reset
                    </Button>
                </div>
                <div>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setInsuranceDetailsModel({ open: true, data: {} })
                            getCountryList()
                            setInsuranceData(true)
                        }}
                        startIcon={<AddIcon />}
                    >
                        Add
                    </Button>
                </div>
            </div>
            <div className="container-fluid mt-2 text-center">
                <Box sx={{ width: '100%' }}>
                    <Paper sx={{ width: '100%', mb: 2 }}>
                        <TableContainer style={{ minHeight: '28vh' }}>
                            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                                <TableHeader dataCount={insuranceList?.length} headData={insurancListHeadCells} />
                                <TableBody>
                                    {insuranceList?.length === 0 ? (
                                        <tr>
                                            <td colSpan={10} className="text-center py-4">
                                                No insurance plans available.
                                            </td>
                                        </tr>
                                    ) : (
                                        // insuranceList?.map((ins, idx) => {
                                        //     return (
                                        //         <TableRow key={ins._id || idx} style={{ background: ins.isActive ? '#DFEADC' : '#fdbaa8' }}>
                                        //             <TableCell>{controller.rowsPerPage * (controller.page - 1) + idx + 1}</TableCell>
                                        //             <TableCell>
                                        //                 {ins.insurance_name ? ins?.insurance_company_id?.companyName : ins.insurance_name}{' '}
                                        //                 {ins.isActive === false && <span>(Disabled)</span>}
                                        //             </TableCell>
                                        //             <TableCell>
                                        //                 {ins.insurance_address}, {ins.insurance_city}, {ins.insurance_zip_code}
                                        //             </TableCell>
                                        //             <TableCell>{ins.mobile_no}</TableCell>
                                        //             <TableCell>{ins.coverage}</TableCell>
                                        //             <TableCell>{ins.insurance_plan_type}</TableCell>
                                        //             <TableCell>{ins.insurance_type}</TableCell>
                                        //             <TableCell>
                                        //                 <b>{ins.isActive ? 'Enable' : 'Disable'}</b>
                                        //             </TableCell>
                                        //             <TableCell>
                                        //                 <div className="dropdown p-0  align-items-center justify-content-center">
                                        //                     <i
                                        //                         style={{ cursor: 'pointer' }}
                                        //                         className="fa-solid fa-ellipsis-vertical  px-3"
                                        //                         id="dropdownMenuLink"
                                        //                         data-bs-toggle="dropdown"
                                        //                         aria-expanded="false"
                                        //                     ></i>
                                        //                     <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        //                         <li
                                        //                             className="dropdown-item"
                                        //                             onClick={() => {
                                        //                                 setInsuranceDetailsModel({ open: true, data: ins })
                                        //                                 getCountryList()
                                        //                                 setInsuranceData(ins)
                                        //                             }}
                                        //                         >
                                        //                             Edit Details
                                        //                         </li>
                                        //                         {ins.note && (
                                        //                             <li className="dropdown-item" onClick={() => setNotesModel({ open: true, data: { note: ins.note } })}>
                                        //                                 View Note
                                        //                             </li>
                                        //                         )}
                                        //                         <li className="dropdown-item" onClick={() => changeStatusInsurance(ins)}>
                                        //                             {ins.isActive ? 'Disable' : 'Enable'}
                                        //                         </li>
                                        //                     </ul>
                                        //                 </div>
                                        //             </TableCell>
                                        //             <TableCell style={{ maxWidth: 300, overflowWrap: 'break-word' }}>
                                        //                 {ins.note ? `${ins.note?.substring(0, 100)}${ins.note.length > 100 ? '...' : ''}` : '--'}
                                        //             </TableCell>
                                        //         </TableRow>
                                        //     )
                                        // })
                                        insuranceList
  ?.slice() // avoid mutating original array
  .sort((a, b) => {
    if (a.coverage === "Primary" && b.coverage !== "Primary") return -1;
    if (a.coverage !== "Primary" && b.coverage === "Primary") return 1;
    return 0;
  })
  .map((ins, idx) => {
    return (
      <TableRow
        key={ins._id || idx}
        style={{ background: ins.isActive ? '#DFEADC' : '#fdbaa8' }}
      >
        <TableCell>
          {controller.rowsPerPage * (controller.page - 1) + idx + 1}
        </TableCell>

        <TableCell>
          {ins.insurance_name
            ? ins?.insurance_company_id?.companyName
            : ins.insurance_name}{' '}
          {ins.isActive === false && <span>(Disabled)</span>}
        </TableCell>

        <TableCell>
          {ins.insurance_address}, {ins.insurance_city},{' '}
          {ins.insurance_zip_code}
        </TableCell>

        <TableCell>{ins.mobile_no}</TableCell>
        <TableCell>{ins.coverage}</TableCell>
        <TableCell>{ins.insurance_plan_type}</TableCell>
        <TableCell>{ins.insurance_type}</TableCell>

        <TableCell>
          <b>{ins.isActive ? 'Enable' : 'Disable'}</b>
        </TableCell>

        <TableCell>
          <div className="dropdown p-0 align-items-center justify-content-center">
            <i
              style={{ cursor: 'pointer' }}
              className="fa-solid fa-ellipsis-vertical px-3"
              data-bs-toggle="dropdown"
            ></i>

            <ul className="dropdown-menu">
              <li
                className="dropdown-item"
                onClick={() => {
                  setInsuranceDetailsModel({ open: true, data: ins })
                  getCountryList()
                  setInsuranceData(ins)
                }}
              >
                Edit Details
              </li>

              {ins.note && (
                <li
                  className="dropdown-item"
                  onClick={() =>
                    setNotesModel({ open: true, data: { note: ins.note } })
                  }
                >
                  View Note
                </li>
              )}

              <li
                className="dropdown-item"
                onClick={() => changeStatusInsurance(ins)}
              >
                {ins.isActive ? 'Disable' : 'Enable'}
              </li>
            </ul>
          </div>
        </TableCell>

        <TableCell style={{ maxWidth: 300, overflowWrap: 'break-word' }}>
          {ins.note
            ? `${ins.note.substring(0, 100)}${
                ins.note.length > 100 ? '...' : ''
              }`
            : '--'}
        </TableCell>
      </TableRow>
    )
  })

                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination count={totalCount} controller={controller} setController={setController} />
                    </Paper>
                </Box>
            </div>

            {/* Note Model */}
            <Modal show={notesModel.open || false} centered>
                <Modal.Header closeButton className="py-2" onClick={() => setNotesModel({ open: false, data: {} })}>
                    Note
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column">{notesModel.data?.note}</div>
                </Modal.Body>
            </Modal>

            {/* Insurance View Model */}
            <Modal show={insuranceDetailsModel.open || false} size="xl" centered>
                <Modal.Header
                    closeButton
                    className="py-2"
                    onClick={() => {
                        setInsuranceDetailsModel({ open: false, data: {} })
                        setdate({ date_of_birth: null, issue_date: null })
                        setUserIdCard([])
                    }}
                >
                    <b>{Object.keys(insuranceDetailsModel.data || {}).length > 0 ? 'Insurance Details' : 'Add Insurance'}</b>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column">
                        {Object.keys(insuranceDetailsModel.data || {}).length > 0 ? (
                            <h5 className="font-14px">
                                <b>Subscriber Information</b>
                                <span className="colorlite">__________________________</span>
                            </h5>
                        ) : (
                            <h5 className="d-flex justify-content-between align-items-end font-14px">
                                <div>
                                    <b>Subscriber Information</b>
                                    <span className="colorlite">__________________________</span>
                                </div>
                                <div className="d-flex">
                                    <div style={{ width: '130px' }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Coverage</InputLabel>
                                            <Select
                                                name="coverage"
                                                className="w-100"
                                                size="small"
                                                label="Coverage"
                                                value={coverage || ''}
                                                onChange={(e) => setcoverage(e.target.value)}
                                            >
                                                <MenuItem value="Primary">Primary</MenuItem>
                                                <MenuItem value="Secondary">Secondary</MenuItem>
                                                <MenuItem value="Tertiary">Tertiary</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <Button className="insurance-auto-fill-btn ms-2" variant="contained" onClick={autoFill}>
                                        Auto fill
                                    </Button>
                                </div>
                            </h5>
                        )}
                        <div className="row">
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_first_name || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    label="Subscriber First Name"
                                    error={validation?.subscriber_first_name}
                                    name="subscriber_first_name"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_last_name || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.subscriber_last_name}
                                    label="Subscriber Last Name"
                                    name="subscriber_last_name"
                                />
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Gender</InputLabel>
                                    <Select
                                        name="subscriber_gender"
                                        className="w-100"
                                        size="small"
                                        label="Gender"
                                        value={addSubscriberData?.subscriber_gender || ''}
                                        onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    >
                                        <MenuItem value="M">Male</MenuItem>
                                        <MenuItem value="F">Female</MenuItem>
                                        <MenuItem value="O">Other</MenuItem>
                                    </Select>
                                </FormControl>
                                {validation?.subscriber_gender && <p className="err">{validation?.subscriber_gender}</p>}
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_id || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.subscriber_id}
                                    label="Subscriber ID"
                                    name="subscriber_id"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.group_number || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.group_number}
                                    label="Group#"
                                    name="group_number"
                                />
                            </div>
                            <div className="col-lg-3 mt-2">
                                <DatePicker
                                    width={'100%'}
                                    inputFormat="MM/dd/yyyy"
                                    maxDate={new Date()}
                                    handleDateChange={(value) => handleDateChange(value, 'date_of_birth')}
                                    SelectedDate={date?.date_of_birth || null}
                                    Lable="Date of Birth"
                                />
                                {validation?.date_of_birth && <p className="err">{validation?.date_of_birth}</p>}
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Relationship</InputLabel>
                                    <Select
                                        name="relationship"
                                        className="w-100"
                                        size="small"
                                        label="Relationship"
                                        onBlur={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                        value={addSubscriberData?.relationship || ''}
                                        onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    >
                                        <MenuItem value="Self">Self</MenuItem>
                                        <MenuItem value="Brother">Brother</MenuItem>
                                        <MenuItem value="Sister">Sister</MenuItem>
                                        <MenuItem value="Mother">Mother</MenuItem>
                                        <MenuItem value="Father">Father</MenuItem>
                                        <MenuItem value="Son">Son</MenuItem>
                                        <MenuItem value="Daughter">Daughter</MenuItem>
                                        <MenuItem value="Grandfather">Grandfather</MenuItem>
                                        <MenuItem value="Grandmother">Grandmother</MenuItem>
                                    </Select>
                                </FormControl>
                                {validation?.relationship && <p className="err">{validation?.relationship}</p>}
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_address || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.subscriber_address}
                                    label="Street Address"
                                    name="subscriber_address"
                                />
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Country</InputLabel>
                                    <Select
                                        name="subscriber_country"
                                        className="w-100"
                                        size="small"
                                        label="Country"
                                        onBlur={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                        value={addSubscriberData?.subscriber_country || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'SUBSCRIBER')
                                        }}
                                    >
                                        {ListCountry?.map((cur, index) => {
                                            return (
                                                <MenuItem key={index} value={cur._id}>
                                                    {cur.countryName}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                {validation?.subscriber_country && <p className="err">{validation?.subscriber_country}</p>}
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>State</InputLabel>
                                    <Select
                                        name="subscriber_state"
                                        className="w-100"
                                        size="small"
                                        label="State"
                                        onBlur={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                        value={addSubscriberData?.subscriber_state || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'SUBSCRIBER')
                                            handleChangeCountry(e.target.value)
                                        }}
                                    >
                                        {ListState?.map((cur, index) => {
                                            return (
                                                <MenuItem key={index} value={cur._id}>
                                                    {cur.stateName}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                {validation?.subscriber_state && <p className="err">{validation?.subscriber_state}</p>}
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_city || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.subscriber_city}
                                    label="City"
                                    name="subscriber_city"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addSubscriberData?.subscriber_zip_code || ''}
                                    onChange={(e) => handleInputChange(e, 'SUBSCRIBER')}
                                    error={validation?.subscriber_zip_code}
                                    label="ZIP Code"
                                    name="subscriber_zip_code"
                                />
                            </div>
                        </div>

                        <h5 className="mt-3 font-14px">
                            <b>Insurance Card Details</b>
                            <span className="colorlite">__________________________</span>
                        </h5>

                        <div className="row">
                            {userIdCard?.map((doc, index) => {
                                return (
                                    <div key={index} className="position-relative ms-2 d-flex flex-column align-items-center justify-content-center insurance-card-box">
                                        <div
                                            className="position-absolute top-0 end-0 m-1"
                                            title="Delete Document"
                                            style={{ cursor: 'pointer', zIndex: 10, color: ' #ff4f4f' }}
                                            onClick={() => handleRemoveDocument(index)}
                                        >
                                            <ClearIcon />
                                        </div>
                                        <div className="mb-2">{doc?.title}</div>
                                        <div>
                                            <img
                                                src={filePdf}
                                                alt=""
                                                title="Click to preview"
                                                onClick={() => window.open(`${environment.baseURL}/${doc?.image}`)}
                                                style={{ width: '60px', height: '60px', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                            {userIdCard?.length < 5 ? (
                                <div className="ms-2 d-flex flex-column align-items-center insurance-card-box">
                                    <div id="standard-basic" className="mt-2">
                                        <TextField className="w-100" value={userIdCardForm?.title || ''} onChange={(e) => handleUploadChange(e)} label="Title" name="title" />
                                    </div>
                                    {userIdCardForm?.image ? (
                                        <div className="d-flex flex-column align-items-center">
                                            <img
                                                src={filePdf}
                                                alt=""
                                                title="Click to preview"
                                                onClick={() => window.open(`${environment.baseURL}/${userIdCardForm?.image}`)}


                                                style={{ width: '60px', height: '60px', cursor: 'pointer' }}
                                            />
                                            <div onClick={() => handleRemoveDocument()} style={{ fontSize: '10px', color: '#ff4f4f', cursor: 'pointer' }}>
                                                Remove
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="mt-2" style={{ cursor: 'pointer' }} onClick={() => document.getElementById('insurance-card-upload').click()}>
                                            <DriveFolderUploadIcon titleAccess="Click to select file" style={{ height: '60px', width: '60px', color: ' rgb(52, 152, 219)' }} />
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        name="image"
                                        accept="image/*"
                                        id="insurance-card-upload"
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleUploadChange(e)}
                                    />
                                </div>
                            ) : null}
                            {userIdCard?.length < 5 ? (
                                <div className="ms-2 d-flex align-items-center justify-content-center insurance-card-box">
                                    <AddIcon
                                        style={{ height: '70px', width: '70px', cursor: 'pointer', color: ' rgb(52, 152, 219)' }}
                                        titleAccess="Save & Add New"
                                        onClick={() => {
                                            saveAndAddNew()
                                        }}
                                    />
                                </div>
                            ) : null}
                        </div>

                        <h5 className="mt-3 font-14px">
                            <b>Insurance Information</b>
                            <span className="colorlite">__________________________</span>
                        </h5>

                        <div className="row">
                            <div className="col-lg-3 mt-2">
                                <Autocomplete
                                    onChange={(e, newValue) => {
                                        handleInputChange({ target: { name: 'insurance_company_id', value: newValue } })
                                    }}
                                    disableClearable={false}
                                    size="small"
                                    clearOnEscape
                                    sx={{ width: '100%' }}
                                    value={addInsuranceData?.insurance_company_id || null}
                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                    options={currentUser?.insuranceList}
                                    getOptionLabel={(option) => `${option?.companyName} (${option?.cpid || '--'})`}
                                    renderInput={(params) => <TextField {...params} label="Insurance" />}
                                    renderOption={(props, option) => {
                                        return (
                                            <li
                                                style={{ fontSize: 14 }}
                                                {...props}
                                                key={option?._id}
                                                title={`
                                                        Name: ${option?.companyName}
                                                        Address: ${option?.address}
                                                        City: ${option?.city}
                                                        Cpid: ${option?.cpid}
                                                        Payer Id: ${option?.payer_id}
                                                `}
                                            >
                                                {`${option?.companyName} (${option?.cpid || '--'})`}
                                            </li>
                                        )
                                    }}
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <InputMask mask="+1 (999) 999 9999" value={addInsuranceData.mobile_no || ''} onChange={(e) => handleInputChange(e, 'INSURANCE')}>
                                    {(inputProps) => (
                                        <TextField {...inputProps} className="w-100" label="Insurance Contact Number" name="mobile_no" error={validation?.mobile_no} />
                                    )}
                                </InputMask>
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Insurance Type</InputLabel>
                                    <Select
                                        name="insurance_type"
                                        className="w-100"
                                        size="small"
                                        label="Insurance Type"
                                        onBlur={(e) => handleInputChange(e, 'INSURANCE')}
                                        value={addInsuranceData?.insurance_type || ''}
                                        onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    >
                                        <MenuItem value="HMO">HMO</MenuItem>
                                        <MenuItem value="PPO">PPO</MenuItem>
                                        <MenuItem value="EAP">EAP</MenuItem>
                                        <MenuItem value="EPO">EPO</MenuItem>
                                        <MenuItem value="Unknown">Unknown</MenuItem>
                                    </Select>
                                </FormControl>
                                {validation?.insurance_type && <p className="err">{validation?.insurance_type}</p>}
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Plan Type</InputLabel>
                                    <Select
                                        name="insurance_plan_type"
                                        className="w-100"
                                        size="small"
                                        label="Plan Type"
                                        onBlur={(e) => handleInputChange(e, 'INSURANCE')}
                                        value={addInsuranceData?.insurance_plan_type || ''}
                                        onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    >
                                        {PlanTypeData.map((item, index) => (
                                            <MenuItem key={index} value={item.code}>
                                                {item.description}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {validation?.insurance_plan_type && <p className="err">{validation?.insurance_plan_type}</p>}
                            </div>
                            <div className="col-lg-3 mt-2">
                                <DatePicker
                                    width={'100%'}
                                    inputFormat="MM/dd/yyyy"
                                    handleDateChange={(value) => handleDateChange(value, 'issue_date')}
                                    SelectedDate={date?.issue_date || null}
                                    Lable="Issue Date"
                                />
                                {validation?.issue_date && <p className="err">{validation?.issue_date}</p>}
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.insurance_address || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.insurance_address}
                                    label="Street Address"
                                    name="insurance_address"
                                />
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>Country</InputLabel>
                                    <Select
                                        name="insurance_country"
                                        className="w-100"
                                        size="small"
                                        label="Country"
                                        onBlur={(e) => handleInputChange(e, 'INSURANCE')}
                                        value={addInsuranceData?.insurance_country || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'INSURANCE')
                                            handleChangeCountryForInsurance(e.target.value)
                                        }}
                                    >
                                        {ListCountry?.map((cur, index) => {
                                            return (
                                                <MenuItem key={index} value={cur._id}>
                                                    {cur.countryName}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                {validation?.insurance_country && <p className="err">{validation?.insurance_country}</p>}
                            </div>
                            <div className="col-lg-3 mt-2">
                                <FormControl fullWidth>
                                    <InputLabel>State</InputLabel>
                                    <Select
                                        name="insurance_state"
                                        className="w-100"
                                        size="small"
                                        label="State"
                                        onBlur={(e) => handleInputChange(e, 'INSURANCE')}
                                        value={addInsuranceData?.insurance_state || ''}
                                        onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    >
                                        {ListStateInsurrance?.map((cur, index) => {
                                            return (
                                                <MenuItem key={index} value={cur._id}>
                                                    {cur.stateName}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                {validation?.insurance_state && <p className="err">{validation?.insurance_state}</p>}
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.insurance_city || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.insurance_city}
                                    label="City"
                                    name="insurance_city"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.insurance_zip_code || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.insurance_zip_code}
                                    label="ZIP Code"
                                    name="insurance_zip_code"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.payer_id || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.payer_id}
                                    label="Payer ID"
                                    name="payer_id"
                                />
                            </div>
                            <div className="col-lg-3 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.copay || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.copay}
                                    label="Copay"
                                    name="copay"
                                />
                            </div>
                            <div className="col-lg-12 mt-2" id="standard-basic">
                                <TextField
                                    className="w-100"
                                    value={addInsuranceData?.note || ''}
                                    onChange={(e) => handleInputChange(e, 'INSURANCE')}
                                    error={validation?.note}
                                    label="Note"
                                    multiline
                                    rows={3}
                                    name="note"
                                />
                            </div>
                        </div>

                        <div className="mt-3 text-center">
                            {Object.keys(insuranceDetailsModel.data || {}).length > 0 ? (
                                <button type="button" className="btn ms-4" style={{ padding: '8px 80px', backgroundColor: '#3069DE', color: 'white' }} onClick={UpdateInsurance}>
                                    Update
                                </button>
                            ) : (
                                <button type="button" className="btn ms-4" style={{ padding: '8px 80px', backgroundColor: '#3069DE', color: 'white' }} onClick={submit}>
                                    Save
                                </button>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
